import { render, staticRenderFns } from "./Intervencao.vue?vue&type=template&id=698b088c&"
import script from "./Intervencao.vue?vue&type=script&lang=js&"
export * from "./Intervencao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports